import { View } from 'react-native'
import Icon from '@ui/elements/Icon'
import Typography from '@ui/typography'
import { useTextPaperContext } from '@ui/elements/TextPaper'

interface Props {
  accepted: boolean
  label: string
}

export default function PolicyRow({ accepted, label }: Props) {
  const { lineColor, lineVariant } = useTextPaperContext()

  return (
    <View className="flex-row items-center gap-3">
      <Icon
        name={accepted ? 'point-filled' : 'point'}
        size={18}
        color={lineColor}
      />
      <Typography variant={lineVariant} color={lineColor}>
        {label}
      </Typography>
    </View>
  )
}
